import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

interface IProps {
  facility: racehorse360.IFacility;
  size: number;
  marginRight?: number;
}

const FacilityMarkerIndicator = (props: IProps) => {
  const { facility, size, marginRight } = props;

  const classes = useStyles({
    backgroundColor: facility?.backgroundColor,
    size,
    marginRight
  });

  return <div className={classes.indicator} />;
};

export default FacilityMarkerIndicator;
